<template>

    <section class="board-view-section mx-xl-4 pt-3 pb-1" data-aos="fade-up">

        <draggable tag="div" class="d-flex" :list="sets" v-bind="setsDragOptions" @change="elementsOrderChange">

            <div class="set-column" v-for="set in sets" :key="set.output_identification_name">

                <div class="set-element" :class="{'checked': checkedSets.includes(set.output_identification_name)}">
                    <div class="image" :style="set.has_icon ? {'background-image': 'url(' + set.icon_url + ')'} : {'background': '#000000'}"></div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="checkedSets" :value="set.output_identification_name" @change="checkedSetsChange(set.output_identification_name)">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="bottom-bar">
                        <div class="handler set-handler" :class="{'hidden': selectedSortType !== 'order'}"></div>
                        <div class="name">{{ set.display_name }}</div>
                        <div class="edit-btn" @click="editSet(set)"></div>
                    </div>
                </div>

                <div class="games" :style="[set.games.length ? {'margin-bottom': '15px'} : {}]">

                    <draggable tag="div" :list="set.games" v-bind="gamesDragOptions" @change="elementsOrderChange">

                        <div class="game-element" v-for="game in set.games" :key="game.output_identification_name" :class="{'checked': checkedGames.includes(game.output_identification_name)}">
                            <div class="image" :style="game.has_icon ? {'background-image': 'url(' + game.icon_url + ')'} : {'background': '#000000'}"></div>
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" v-model="checkedGames" :value="game.output_identification_name" @change="checkedGamesChange(game.output_identification_name)">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="mechanisms-color" :class="game.mechanism"></div>
                            <div class="bottom-bar">
                                <div class="handler game-handler" :class="{'hidden': selectedSortType !== 'order'}"></div>
                                <div class="name">{{ game.display_name }}</div>
                                <a v-if="game.mechanism" :href="'/my-quizzes/edit-game/' + game.output_identification_name" class="edit-btn"></a>
                            </div>
                        </div>

                    </draggable>

                </div>

                <div v-if="set.output_identification_name !== 'default'" class="add-game-btn" @click="addGame(set)">
                    <div class="icon"></div>
                    <div class="text">{{ t.__('Dodaj grę') }}</div>
                </div>

            </div>

        </draggable>

        <div>
            <div class="add-set-btn" @click="addSet">
                <div class="icon-wrapper">
                    <div class="icon"></div>
                </div>
                <div class="text">{{ t.__('Dodaj zestaw') }}</div>
            </div>
        </div>

    </section>

</template>

<script>

import draggable from 'vuedraggable'
import Scrollbar from 'smooth-scrollbar';

export default {

    name: 'MyQuizzesBoardView',

    components: {
        draggable
    },

    props: {
        sets: Array,
        selectedSortType: String
    },

    data() {
        return {
            eventHub: window.eventHub,
            checkedSets: [],
            checkedGames: [],
            setsDragOptions: {
                animation: 200,
                group: 'sets',
                disabled: false,
                ghostClass: 'ghost',
                handle: '.set-handler',
                draggable: '.set-column',
                dragoverBubble: true
            },
            gamesDragOptions: {
                animation: 200,
                group: 'games',
                disabled: false,
                ghostClass: 'ghost',
                handle: '.game-handler',
                draggable: '.game-element',
                dragoverBubble: true
            }
        };
    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-delete-elements-start', () => {
            let data = {
                sets: this.checkedSets,
                games: this.checkedGames
            };
            axios.post('/my-quizzes/delete-elements', data)
                .then(response => {
                    this.eventHub.$emit('my-quizzes-update-sets', response.data.sets);
                    this.eventHub.$emit('my-quizzes-delete-elements-complete');
                    this.checkedSets = [];
                    this.checkedGames = [];
                })
                .catch(error => {
                    console.log(error);
                });
        });

    },

    mounted() {
        document.querySelectorAll('.games').forEach(element => {
            Scrollbar.init(element, {
                alwaysShowTracks: true
            });
        });
    },

    methods: {

        checkedSetsChange(setOutputIdentificationName) {
            let set = this.sets.find(obj => {
                return obj.output_identification_name === setOutputIdentificationName
            });
            if (this.checkedSets.includes(setOutputIdentificationName)) {
                set.games.forEach(game => {
                    if (!this.checkedGames.includes(game.output_identification_name)) {
                        this.checkedGames.push(game.output_identification_name);
                    }
                });
            } else {
                set.games.forEach(game => {
                    if (this.checkedGames.includes(game.output_identification_name)) {
                        this.checkedGames.splice(this.checkedGames.indexOf(game.output_identification_name), 1);
                    }
                });
            }
        },

        checkedGamesChange(gameOutputIdentificationName) {
            let set = this.sets.find(objSet => {
                return objSet.games.find(objGame => {
                    return objGame.output_identification_name === gameOutputIdentificationName
                });
            });
            if (this.checkedSets.includes(set.output_identification_name)) {
                this.checkedSets.splice(this.checkedSets.indexOf(set.output_identification_name), 1);
            }
        },

        addSet() {
            this.eventHub.$emit('my-quizzes-add-set');
        },

        editSet(set) {
            this.eventHub.$emit('my-quizzes-edit-set', set);
        },

        addGame(set) {
            this.eventHub.$emit('my-quizzes-add-game', set);
        },

        elementsOrderChange() {
            this.eventHub.$emit('my-quizzes-order-changed', this.sets);
        }

    }

}
</script>

<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
